import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import { useGetTranslations } from '@/composables/useGetTranslations';
import AzImg from '~/components/Atoms/AzImg.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
export default defineComponent({
  name: 'MenuItem',
  components: {
    AzImg: AzImg,
    AzIcon: AzIcon
  },
  props: {
    titleStyle: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    hideArrow: {
      type: Boolean,
      default: false
    },
    hideSubtitle: {
      type: Boolean,
      default: false
    },
    hideImage: {
      type: Boolean,
      default: false
    },
    hideLink: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  setup: function setup(props) {
    var router = useRouter();
    var _useMobileObserver = useMobileObserver(),
      isMobile = _useMobileObserver.isMobile;
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var routerPush = function routerPush(link) {
      router.push(link);
    };
    return {
      routerPush: routerPush,
      isMobile: isMobile,
      translate: translate,
      classesToApply: computed(function () {
        return props.titleStyle.map(function (selector) {
          return "menu-item__text_".concat(selector);
        });
      })
    };
  }
});